import type { API } from 'api/config/types';
import { Core } from 'chessboard/core/config/types';
import { calculateTimestampValue } from 'chessboard/model/move/calculate-timestamp-value';

/**
 * Create the set times for the times API
 */
export function createSetManyTimes(context) {
  /**
   * Set times on all move nodes and create timestamps as well
   */
  return function setMany(times: number[] = []): API.Response {
    const { api, respond } = context;

    api.getRawLines()[0].forEach((node, index) => {
      if (times[index] === undefined) {
        return;
      }

      if (!node.time && times[index]) {
        node.time = <number>times[index];
      }

      api.timestamps.set(calculateTimestampValue({ api, node }), index);
    });

    return respond(Core.APIEvents.LineUpdated);
  };
}
